@if (svgPath) {
  <span class="icon">
    <img [src]="svgPath" [alt]="name" />
  </span>
}
